import { jsx as _jsx } from "react/jsx-runtime";
// Регулярное выражение для нахождения URL в тексте
const URL_REGEXP = /\bhttps?:\/\/\S+/gi;
export const linkify = (inputText) => {
    // Если в тексте нет URL, просто возвращаем его
    if (!URL_REGEXP.test(inputText)) {
        return [inputText];
    }
    // Если в тексте есть URL, нужно сбросить позицию регулярного выражения
    // после использования метода test()
    URL_REGEXP.lastIndex = 0;
    // Массив для хранения разделенного текста и JSX-элементов ссылок
    const parts = [];
    let match;
    let lastIndex = 0;
    // Итерация по всем совпадениям URL в тексте
    while ((match = URL_REGEXP.exec(inputText)) !== null) {
        const link = match[0];
        const linkStartIndex = match.index;
        // Если URL не начинается сразу с начала строки, добавляем текст перед URL в parts
        if (linkStartIndex > lastIndex)
            parts.push(inputText.slice(lastIndex, linkStartIndex));
        // Создание JSX-элемент ссылки для каждого URL и добавьте его в parts
        parts.push(_jsx("a", { href: link, target: '_blank', rel: 'noreferrer noopener', children: link }, link));
        // Обновляем lastIndex, чтобы он указывал на конец последнего найденного URL
        lastIndex = URL_REGEXP.lastIndex;
    }
    // Если текст остается после последнего URL, добавляем его в parts
    if (lastIndex < inputText.length)
        parts.push(inputText.slice(lastIndex));
    return parts;
};
